import { graphql } from "@/lib/gql/__generated__/gql";

export const DayTripPlanI18nEditDefaultQuery = graphql(`
	query DayTripPlanI18nEdit($hotelID: ID!, $planId: ID!, $lang: LangCode!) {
		planI18n(hotelID: $hotelID, planID: $planId, lang: $lang) {
			id
			lang
			hotelID
			planID
			name
			mainTarget
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
			articleTitle
			emailTemplateReservation {
				atCreated
				atUpdated
				atCanceled
				atCin
			}
			questions {
				questionID
				required
				questionType
				question
				options
			}
		}
		hotelPolicyI18n(hotelID: $hotelID, lang: $lang) {
			id
			lang
			questions {
				questionID
				required
				questionType
				question
				options
			}
		}
		customEmailSettingI18n(hotelID: $hotelID, lang: $lang) {
			id
			lang
			reservation {
				atCreated
				atUpdated
				atCanceled
				atCin
			}
		}
		hotel(hotelID: $hotelID) {
			id
			hotelID
			companyID
			email
		}
		planCustomMailSettingI18n(hotelID: $hotelID, planID: $planId, lang: $lang) {
			id
			planID
			forReservation {
				atCreated {
					text
					override
				}
				atUpdated {
					text
					override
				}
				atCanceled {
					text
					override
				}
				atCheckInBefore_00days {
					text
					shouldSendEmail
					override
				}
				atCheckInBefore_01days {
					text
					shouldSendEmail
					override
				}
				atCheckInBefore_07days {
					text
					shouldSendEmail
					override
				}
				atCheckOutAfter_01days {
					text
					shouldSendEmail
					override
				}
			}
		}
		planCustomMailSetting(hotelID: $hotelID, planID: $planId) {
			id
			planID
			forReservation {
				atCreated {
					text
					override
				}
				atUpdated {
					text
					override
				}
				atCanceled {
					text
					override
				}
				atCheckInBefore_00days {
					text
					shouldSendEmail
					override
				}
				atCheckInBefore_01days {
					text
					shouldSendEmail
					override
				}
				atCheckInBefore_07days {
					text
					shouldSendEmail
					override
				}
				atCheckOutAfter_01days {
					text
					shouldSendEmail
					override
				}
			}
		}
		basicCustomMailSettingI18n(hotelID: $hotelID, lang: $lang) {
			id
			forReservation {
				atCreated {
					text
				}
				atUpdated {
					text
				}
				atCanceled {
					text
				}
				atCheckInBefore_00days {
					text
					shouldSendEmail
				}
				atCheckInBefore_01days {
					text
					shouldSendEmail
				}
				atCheckInBefore_07days {
					text
					shouldSendEmail
				}
				atCheckOutAfter_01days {
					text
					shouldSendEmail
				}
			}
		}
	}
`);
